import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, L } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { StoryCard } from "@/components/news/StoryCard";
import { Button } from "@/components/ui/button";

export default function ListingPage({ mode }) {
  const { slug, type } = useParams();
  const { lang } = useSite();
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({ page: 1, pages: 1 });
  const [cat, setCat] = useState(null);
  const [error, setError] = useState("");

  const load = async (page = 1) => {
    const params = mode === "category" ? { category: slug, page } : { trend: type, page };
    try {
      const { data } = await api.get("/public/stories", { params });
      setItems((prev) => (page === 1 ? data.items : [...prev, ...data.items]));
      setMeta({ page: data.page, pages: data.pages });
      setCat(data.category);
      setError("");
    } catch {
      setError("This section could not be found.");
    }
  };

  useEffect(() => {
    load(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, type, mode]);

  const title = mode === "category" ? (cat ? (lang === "ta" ? cat.name_ta : cat.name_en) : "") : L(type, lang);

  return (
    <div data-testid="listing-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 fade-in">
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-zinc-500">{mode === "category" ? "Section" : "Trend"}</p>
      <h1 data-testid="listing-title" className={`font-serif-head font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl border-b-2 border-zinc-900 pb-6 mb-10 ${lang === "ta" ? "lang-ta" : ""}`}>
        {title}
      </h1>
      {error && <p data-testid="listing-error" className="text-zinc-500">{error}</p>}
      {!error && items.length === 0 && <p data-testid="listing-empty" className="text-zinc-500">{L("empty", lang)}</p>}
      <div className="grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((s) => <StoryCard key={s.id} story={s} lang={lang} />)}
      </div>
      {meta.page < meta.pages && (
        <div className="mt-12">
          <Button data-testid="listing-load-more" variant="outline" className="rounded-none border-zinc-900" onClick={() => load(meta.page + 1)}>
            Load more
          </Button>
        </div>
      )}
    </div>
  );
}
